;(function () {
  'use strict';
  var $form = $('form[data-report-post-form]');
  var $map = $form.find('.google-place-api');
  // GooglePlaceAPIオートコンプリート のEnter key でのsubmitの禁止
  $map.on("keypress", function (e) {
    if (e.keyCode == 13) {
      return false;
    }
  });

}.call(this));